import i18n from "../i18n";

export const useLanguageCode = () => {
  return i18n.language;
};
